import React, { useState, useEffect } from "react";
import { Card, CardMedia, CardContent, Typography } from "@mui/material";
import ScrollReveal from "scrollreveal";

// Card data in JSON format
const cardData = [
  {
    id: 798,
    title: "GENERAL TALKS",
    image:
      "https://sastraprakasika.com/wp-content/uploads/2018/10/generallib-150x150.png",
    topics: 1,
    volumes: 14,
    link: "/general-talks/798",
  },
];

const SingleCard = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleMouseEnter = (index) => setHoveredIndex(index);
  const handleMouseLeave = () => setHoveredIndex(null);
  
  useEffect(() => {
    ScrollReveal().reveal(".reveal", {
      duration: 2000, // Animation duration (in ms)
      distance: "100px", // Distance the element moves
      origin: "bottom", // Animation starts from the left
      easing: "ease-in-out", // Easing function
      reset: true, // Reset the animation when scrolling back
    });
  }, []);

  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px",
    },
    card: {
      backgroundColor: "#F5F5F5",
      textAlign: "center",
      margin: "10px",
      width: "300px",
      borderRadius: "10px",
      overflow: "hidden",
      transition: "box-shadow 0.3s ease-in-out",
      transition: "transform 0.3s ease-in-out",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    },
    cardHover: {
      boxShadow: "0 4px 15px #8C3A00", // Orange box-shadow on hover
      transform: "scale(1.01)", // Scale-up on hover
    },
    media: {
      height: "250px",
      width: "100%",
      objectFit: "cover",
    },
    label: {
      marginTop: "10px", // Space between image and label
      fontSize: "16px",
      color: "#495057",
    },
    content: {
      padding: "10px 20px",
    },
    contentWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "10px",
    },
    textOrange: {
      color: "orange",
    },
    link: {
      textDecoration: "none",
      color: "inherit",
    },
  };

  return (
    <div
      className="container-sm"
      style={{ marginTop: "20px", minHeight: "100vh" }}
    >
      <div style={styles.container} className="reveal">
        {cardData.map((card, index) => (
          <Card
            key={card.id}
            style={{
              ...styles.card,
              ...(hoveredIndex === index ? styles.cardHover : {}),
            }}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            className="reveal"
          >
            <a href={card.link} style={styles.link}>
              <CardMedia
                component="img"
                image={card.image}
                alt={card.title}
                style={{
                  ...styles.media,
                }}
              />
              <CardContent style={styles.content}>
                <Typography variant="h4" component="div" style={styles.label}>
                  {card.title}
                </Typography>
                <div style={styles.contentWrapper}>
                  <Typography variant="body2" color="text.secondary">
                    No of Topics:{" "}
                    <span style={styles.textOrange}>{card.topics}</span>
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Volumes:{" "}
                    <span style={styles.textOrange}>{card.volumes}</span>
                  </Typography>
                </div>
              </CardContent>
            </a>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default SingleCard;
